import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@mui/material/IconButton';
import { Container } from '@mui/system';
import { ZoomIn } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import favorites from "../api/favorite.json";
import { ArtworkApi } from '../api/artworkApi';

function Home() {
    const
        nav = useNavigate();

    return (
        <>
            <ArtworkApi />
            <Container
                maxWidth="xl"
                sx={{ display: { xs: 'none', md: 'block' } }}
            >
                <ImageList
                    cols={4}
                    gap={8}
                    rowHeight={300}
                    variant="quilted"
                    sx={{ height: 1, mt: 2, width: 1 }}
                >
                    {
                        favorites.map((item, index) => (
                            <ImageListItem
                                key={item.id}
                                cols={item.cols}
                                rows={item.rows}
                            >
                                <img
                                    alt={item.name}
                                    loading="lazy"
                                    src={`https://bytonya.blob.core.windows.net/images/${item.id}.jpg`}
                                    style={{ cursor: "pointer", objectFit: item.cols === 2 && item.rows === 2 ? "cover" : "none" }}
                                    onClick={() => {
                                        nav(`/art/${item.id}`);
                                    }}
                                />
                                <ImageListItemBar
                                    title={item.name}
                                    actionIcon={
                                        <IconButton
                                            onClick={() => {
                                                nav(`/art/${item.id}`);
                                            }}
                                        >
                                            <ZoomIn />
                                        </IconButton>
                                    }
                                />
                            </ImageListItem>
                        ))
                    }
                </ImageList>
            </Container>
            <Box
                sx={{ width: 1, display: { xs: 'block', md: 'none' } }}
            >
                <ImageList
                    cols={1}
                    sx={{ height: 1, mt: 2, width: 1 }}
                >
                    {
                        favorites.map((item, index) => (
                            <ImageListItem
                                key={item.id}
                            >
                                <img
                                    alt={item.name}
                                    loading="lazy"
                                    src={`https://bytonya.blob.core.windows.net/images/${item.id}.jpg`}
                                    style={{ cursor: "pointer", objectFit: "cover" }}
                                    onClick={() => {
                                        nav(`/art/${item.id}`);
                                    }}
                                />
                                <ImageListItemBar
                                    title={item.name}
                                    actionIcon={
                                        <IconButton
                                            onClick={() => {
                                                nav(`/art/${item.id}`);
                                            }}
                                        >
                                            <ZoomIn />
                                        </IconButton>
                                    }
                                />
                            </ImageListItem>
                        ))
                    }
                </ImageList>
            </Box>
        </>
    )
}

export default Home;